module.exports = __webpack_public_path__ + "img/head-img.89f01218.png";